import { Mixpanel } from '../redux/Mixpanel';
import notificationService from '../services/notificationService';

export async function openNotificationPromptIfEligible(setOpen) {
  const canShow = await notificationService.canShowPrompt();
  if (!canShow) {
    return false;
  }
  setOpen(true);
  return true;
}

export async function handleNotificationPromptAllow(setOpen, page) {
  setOpen(false);
  const result = await notificationService.requestPermissionAfterPrompt();
  if (Mixpanel && Mixpanel.track) {
    if (result?.success) {
      Mixpanel.track('notifications:permission_allowed', { page });
    } else {
      Mixpanel.track('notifications:permission_denied', { page });
    }
  }
}

export async function handleNotificationPromptDeny(setOpen, page) {
  setOpen(false);
  await notificationService.recordPromptDismissed();
  if (Mixpanel && Mixpanel.track) {
    Mixpanel.track('notifications:permission_denied', { page });
  }
}

